import React from 'react';

import { TI50Props } from '@interfaces/ti50';
import { AuthoredContentReactToHtmlParser } from '@utils/reactHtmlParserTransform';

import CompanyDetails from './CategorySection/CompanyDetails';

type SEOContentProps = Pick<TI50Props, 'activeCategories' | 'data'>;

const SEOContent = ({ activeCategories, data }: SEOContentProps) => {
  return (
    <div className="seo-paywall-content" data-nosnippet>
      {activeCategories.map(({ category, description }) => (
        <div key={`seo-${category}`}>
          <p className="section-name">{category}</p>
          <p className="section-title">{category}</p>
          <p className="section-description mt2">{AuthoredContentReactToHtmlParser(description)}</p>
          {data[category]?.map((company) => (
            <div key={`seo-${company.company_name}`}>
              <p>Rank: {company.sector_rank}</p>
              <h3>Name: {company.company_name}</h3>
              <p>Valuation: {company.valuation_value}</p>
              <CompanyDetails company={company} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default SEOContent;
